import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/WaterwayRoutes/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/WaterwayRoutes/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/WaterwayRoutes/GetById`, payload),
    Add: (payload) => Repository.post(`/api/WaterwayRoutes/Add`, payload),
    Edit: (payload) => Repository.post(`/api/WaterwayRoutes/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/WaterwayRoutes/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/WaterwayRoutes/ChangeStatus`, payload),
}
